export enum MESSAGE_TYPE {
	Infos = 0,
	Warning = 1,
	Urgent = 2,
}
